// HRProfile.hrprofile_race — MOM statistical reporting and SHG fund routing.
// Work-pass application forms use a shorter CMIO list; do not reuse that here.

export const RACE_OPTIONS = [
  { value: 'chinese', label: 'Chinese' },
  { value: 'malay', label: 'Malay' },
  { value: 'indian', label: 'Indian' },
  { value: 'indonesian', label: 'Indonesian' },
  { value: 'eurasian', label: 'Eurasian' },
  { value: 'others', label: 'Others' },
  { value: 'not_disclosed', label: 'Prefer not to disclose' },
];

export const RACE_DISPLAY = {
  chinese: 'Chinese',
  malay: 'Malay',
  indian: 'Indian',
  indonesian: 'Indonesian',
  eurasian: 'Eurasian',
  others: 'Others',
  not_disclosed: 'Prefer not to disclose',
};
